import { render, staticRenderFns } from "./CheckoutFromMenu.vue?vue&type=template&id=57c6d49a&scoped=true&"
import script from "./CheckoutFromMenu.vue?vue&type=script&lang=js&"
export * from "./CheckoutFromMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c6d49a",
  null
  
)

export default component.exports